import { Controller, useFormContext } from 'react-hook-form';

import { Field } from '@grafana/ui';
import { t } from 'app/core/internationalization';
import { formSchemaValidationRules } from 'app/extensions/reports/utils/validation';
import { ReportBaseV2 } from 'app/extensions/types/reports';

import { DatePickerInput } from './DatePickerInput';

export function EndDateInput() {
  const {
    control,
    watch,
    formState: { errors },
    setValue,
  } = useFormContext<ReportBaseV2>();
  const startDate = watch('schedule.startDate') ?? new Date();

  return (
    <Field
      label={t('share-report.schedule.end-date', 'End date')}
      error={errors.schedule?.endDate?.message}
      invalid={!!errors.schedule?.endDate?.message}
      htmlFor="end-date-picker"
    >
      <Controller
        name="schedule.endDate"
        control={control}
        rules={formSchemaValidationRules(watch()).schedule.endDate}
        render={({ field: { ref, ...field } }) => (
          <DatePickerInput
            id="end-date-picker"
            {...field}
            placeholder={t('share-report.schedule.end-date-placeholder', 'Does not end')}
            minDate={new Date(startDate)}
            onClear={() => setValue('schedule.endDate', '')}
          />
        )}
      />
    </Field>
  );
}
